@if (netzbetreiber) {
    <form #netzbetreiberForm="ngForm"
          [redispatchUniqueTeilgebietAndNetzbetreibernummer]="{
          originalNetzbetreiberValues: originalNetzbetreiber,
          enabled: isWestnetzAdmin
      }"
          data-qa="netzbetreiber-detail-form"
          fxFlex
          fxLayout="column">
        @if (isWestnetzUser) {
            <header>
                <div class="buttons-container">
                    <div class="buttons">
                        <button [matButton]="isWestnetzAdmin ? 'outlined' : 'filled'"
                                type="button"
                                class="actionbutton"
                                data-qa="close-details-button"
                                (click)="closeSideNav()">
                            <mat-icon svgIcon="innogy_picto_close"></mat-icon>
                            {{ (createNewMode || netzbetreiberForm.form.dirty) ? 'Abbrechen' : 'Schließen' }}
                        </button>
                        @if (!createNewMode && isWestnetzAdmin) {
                            <button
                                matButton="outlined"
                                type="button"
                                data-qa="reset-details-button"
                                class="actionbutton"
                                (click)="resetForm()"
                                [disabled]="!netzbetreiberForm.form.dirty">
                                <mat-icon>autorenew</mat-icon>
                                Zurücksetzen
                            </button>
                        }
                        @if (!createNewMode && isWestnetzAdmin) {
                            <button
                                matButton="filled"
                                type="button"
                                data-qa="save-details-button"
                                class="actionbutton"
                                [disabled]="isSaveButtonDisabled()"
                                (click)="saveBasisDaten()">
                                <mat-icon>save</mat-icon>
                                Speichern
                            </button>
                        }
                        @if (createNewMode && isWestnetzAdmin) {
                            <button
                                matButton="filled"
                                type="button"
                                data-qa="create-details-button"
                                class="actionbutton"
                                [disabled]="isSaveButtonDisabled()"
                                (click)="createNetzbetreiber()">
                                <mat-icon>save</mat-icon>
                                Erstellen
                            </button>
                        }
                        @if (!createNewMode && isWestnetzAdmin) {
                            <button
                                matButton="filled"
                                type="button"
                                data-qa="delete-details-button"
                                class="actionbutton button-warn"
                                (click)="deleteNetzbetreiber()">
                                <mat-icon svgIcon="innogy_picto_bin_c-check"></mat-icon>
                                Löschen
                            </button>
                        }
                    </div>
                    @if (netzbetreiberForm.errors) {
                        <div fxLayout="row" fxLayoutAlign="end" class="text-align-end">
                            @if (netzbetreiberForm.hasError('uniqueTeilgebietName')) {
                                <mat-error>
                                    Die Kombination aus Teilgebiet & Netzbetreibernummer <br>
                                    (PGON) existiert bereits. Bitte vergeben Sie eine andere.
                                </mat-error>
                            }
                        </div>
                    }
                </div>
                <div class="stadtwerkeId">
                    <div>Netzbetreiber</div>
                    <span class="stadtwerkeId-title" data-qa="netzbetreiberName">
            @if (!createNewMode) {
                {{ originalNetzbetreiber.name }}
            }
                        @if (createNewMode) {
                            Neuer Netzbetreiber
                        }
          </span>
                </div>
            </header>
        }
        @if (isStadtwerkUser) {
            <h2>Meine Kontaktdaten</h2>
        }
        <div class="input-container" [class.scroll]="!isStadtwerkUser" fxFlex
             [fxLayout]="isStadtwerkUser ? 'row' : 'column'" fxLayoutGap="1rem">
            <div class="basis-data" [fxFlex]="isStadtwerkUser ? '40' : ''"
                 [fxLayout]="isStadtwerkUser ? 'column': 'row'"
                 fxLayoutGap="1rem">
                <div class="detail-main" [fxFlex]="isStadtwerkUser ? '' : '40'" [fxLayout]="'column'">
                    <h3>Basis-Daten</h3>
                    <mat-card fxFlex [fxLayout]="'column'" fxLayoutGap="1rem">
                        <mat-form-field redispatchProvideReadonly>
                            <mat-label>Name des Netzbetreibers</mat-label>
                            <input matInput
                                   [disabled]="!isWestnetzAdmin"
                                   required
                                   [(ngModel)]="netzbetreiber.name"
                                   #name="ngModel"
                                   name="name"/>
                            @if (name?.errors?.required) {
                                <mat-error>
                                    Bitte vergeben Sie einen eindeutigen Namen
                                </mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field redispatchProvideReadonly>
                            <mat-label>Teilgebiet</mat-label>
                            <input matInput
                                   [disabled]="!isWestnetzAdmin"
                                   [(ngModel)]="netzbetreiber.teilgebiet"
                                   #teilgebiet="ngModel"
                                   required
                                   name="teilgebiet"
                                   maxlength="40"/>
                            @if (teilgebiet?.errors?.required) {
                                <mat-error>
                                    Bitte vergeben Sie einen Teilgebiet
                                </mat-error>
                            }
                        </mat-form-field>
                        <div [fxLayout]="isStadtwerkUser ? 'row': 'column'" fxLayoutGap="1rem">
                            <mat-form-field redispatchProvideReadonly fxFlex>
                                <mat-label>Netzbetreibernummer (PGON)</mat-label>
                                <input matInput
                                       [disabled]="!isWestnetzAdmin"
                                       [(ngModel)]="netzbetreiber.netzbetreibernummer"
                                       (ngModelChange)="netzbetreiberNummerChanged()"
                                       #netzbetreibernummer="ngModel"
                                       data-qa="pgon-input-field"
                                       name="netzbetreibernummer"/>
                                @if (netzbetreibernummer?.errors?.uniqueNetzbetreibernummer) {
                                    <mat-error>
                                        Diese Netzbetreibernummer ist bereits vergeben
                                    </mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field redispatchProvideReadonly fxFlex>
                                <mat-label>Stadtwerke-ID</mat-label>
                                <input matInput
                                       [disabled]="!createNewMode"
                                       [required]="createNewMode"
                                       [(ngModel)]="netzbetreiber.stadtwerkeId"
                                       [redispatchAvailableStadtwerkeId]="createNewMode"
                                       #stadtwerkeId="ngModel"
                                       pattern="S[0-9]{3}"
                                       name="stadtwerkeId"/>
                                @if (stadtwerkeId?.errors?.pattern) {
                                    <mat-error>
                                        Die Stadtwerke-ID entspricht nicht dem Muster
                                    </mat-error>
                                }
                                @if (stadtwerkeId?.errors?.availableStadtwerkeId) {
                                    <mat-error>
                                        Diese Stadtwerke-Id ist vergeben
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                        @if (isWestnetzAdmin) {
                            <mat-form-field redispatchProvideReadonly>
                                <mat-label>Geschäftspartner-ID</mat-label>
                                <input matInput
                                       [disabled]="!isWestnetzAdmin"
                                       [(ngModel)]="netzbetreiber.geschaeftspartnerId"
                                       #geschaeftspartnerId="ngModel"
                                       name="geschaeftspartnerId"
                                       maxlength="20"/>
                            </mat-form-field>
                        }
                        @if (isWestnetzAdmin) {
                            <mat-form-field redispatchProvideReadonly class="example-chip-list">
                                <mat-label>Ansprechpartner</mat-label>
                                <mat-chip-grid #chipGrid aria-label="Ansprechpartner selection">
                                    @for (kontaktdaten of netzbetreiber.westnetzKontaktdaten; track kontaktdaten.id) {
                                        <mat-chip-row
                                            [removable]="true"
                                            (removed)="removeAnsprechpartnerFromNetzbetreiber(kontaktdaten)">
                                            {{ kontaktdaten.name }}
                                            <button matChipRemove>
                                                <mat-icon svgIcon="innogy_picto_close"></mat-icon>
                                            </button>
                                        </mat-chip-row>
                                    }
                                    <input
                                        #ansprechpartnerInput
                                        [formControl]="ansprechpartnerForm"
                                        [matAutocomplete]="auto"
                                        [matChipInputFor]="chipGrid">
                                </mat-chip-grid>
                                <mat-autocomplete #auto="matAutocomplete"
                                                  (optionSelected)="selectAnsprechpartner($event)">
                                    @for (kontaktdaten of availableWestnetzKontaktdaten$ | async; track kontaktdaten.id) {
                                        <mat-option
                                            [value]="kontaktdaten">
                                            {{ kontaktdaten.name }}  (Hat {{ kontaktdaten.kontakte.length }}
                                            Kontaktinformationen)
                                        </mat-option>
                                    }
                                </mat-autocomplete>
                            </mat-form-field>
                        }
                        @if (isWestnetzUser && !isWestnetzAdmin) {
                            <mat-form-field redispatchProvideReadonly>
                                <mat-label>Ansprechpartner...</mat-label>
                                <input matInput
                                       [disabled]="true"
                                       [(ngModel)]="westnetzAnsprechpartnerReadonly"
                                       name="ansprechpartnerReadonly"/>
                            </mat-form-field>
                        }
                    </mat-card>
                </div>
                @if (isStadtwerkUser) {
                    <div class="module-main" fxFlex [fxLayout]="'column'">
                        <h3>Dienstleistungsart</h3>
                        <mat-card fxFlex [fxLayout]="'column'" fxLayoutAlign="space-around stretch">
                            <mat-form-field redispatchProvideReadonly>
                                <mat-label>Dienstleistungsart</mat-label>
                                <input matInput
                                       [value]="netzbetreiber.dienstleistungsart?.title"
                                       [disabled]="true"/>
                            </mat-form-field>
                        </mat-card>
                    </div>
                }
                <div class="module-main" fxFlex [fxLayout]="'column'">
                    <h3>Dienstleistungsmodule</h3>
                    <div fxFlex fxLayout="column" fxLayoutGap="1rem">
                        <mat-card fxFlex [fxLayout]="'column'" fxLayoutAlign="space-around stretch">
                            <mat-checkbox [(ngModel)]="netzbetreiber.redispatchEnabled"
                                          [disabled]="!isWestnetzAdmin"
                                          (change)="netzbetreiberForm.form.markAsDirty()"
                                          name="redispatchEnabled"
                                          data-qa="redispatch-enabled-checkbox-field"
                            >
                                <mat-label>Redispatch-relevante Anlagen</mat-label>
                            </mat-checkbox>
                        </mat-card>
                        <mat-card fxFlex [fxLayout]="'column'" fxLayoutAlign="space-around stretch" fxLayoutGap="1rem">
                            @if (isWestnetzAdmin) {
                                <mat-form-field redispatchProvideReadonly>
                                    <mat-label>Dienstleistungsart</mat-label>
                                    <mat-select [(ngModel)]="netzbetreiber.dienstleistungsart"
                                                [compareWith]="isSameDienstleistungsart"
                                                name="selectDienstleistungsart"
                                                id="selectDienstleistungsart">
                                        @for (dienstleistungsart of dienstleistungsarten$ | async; track dienstleistungsart.id) {
                                            <mat-option
                                                [value]="dienstleistungsart">{{ dienstleistungsart.title }}
                                            </mat-option>
                                        }
                                        <mat-option [value]="undefined">None</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                @for (module of availableDienstleistungsmodule$ | async; track module.id) {
                                    <mat-checkbox
                                        [checked]="containsModule(module.dienstleistungsmodule)"
                                        (change)="moduleChanged($event, module.dienstleistungsmodule)"
                                    >
                                        <mat-label
                                            [class.hightlighted]="isHighlighted(module.dienstleistungsmodule)"
                                        >{{ module.title }}
                                        </mat-label>
                                    </mat-checkbox>
                                }
                            }
                            @if (!isWestnetzAdmin && splittedDienstleistungsmodule$ | async; as modules) {
                                <div fxLayout="column">
                                    <h4 class="none-top-margin">Meine Dienstleistungsmodule</h4>
                                    @if (modules.selected.length) {
                                        <ul class="selected">
                                            @for (module of modules.selected; track module.id) {
                                                <li>{{ module.title }}</li>
                                            }
                                        </ul>
                                    } @else {
                                        <ul>
                                            <li>keine</li>
                                        </ul>
                                    }
                                </div>
                                <div fxLayout="column">
                                    <h4>Weitere mögliche Dienstleistungsmodule</h4>
                                    <ul>
                                        @for (module of modules.unselected; track module.id) {
                                            <li>{{ module.title }}</li>
                                        }
                                    </ul>
                                </div>
                            }
                        </mat-card>
                    </div>
                </div>
            </div>
            <!-- KONTAKTDATEN Netzbetreiber -->
            <div class="kontakt-data-main" fxFlex [fxLayout]="'column'" fxLayoutAlign="start stretch">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <h3 fxFlex>Kontaktdaten Netzbetreiber</h3>
                    @if (isStadtwerkUser) {
                        <div class="buttons">
                            <button
                                matButton="outlined"
                                type="button"
                                class="actionbutton"
                                data-qa="reset-details-button"
                                (click)="resetForm()"
                                [disabled]="!netzbetreiberForm.form.dirty">
                                <mat-icon>autorenew</mat-icon>
                                Zurücksetzen
                            </button>
                            <button
                                matButton="filled"
                                type="button"
                                class="actionbutton"
                                data-qa="save-details-button"
                                [disabled]="isSaveButtonDisabled()"
                                (click)="saveContactData()">
                                <mat-icon>save</mat-icon>
                                Speichern
                            </button>
                        </div>
                    }
                </div>
                <mat-card fxFlex fxLayout="row" fxLayoutAlign="space-between stretch" fxLayoutGap="1rem">
                    <div [fxLayout]="'column'" fxFlex fxLayoutGap="1rem">
                        <h4 class="none-top-margin">Ansprechpartner Redispatch</h4>
                        <mat-form-field redispatchProvideReadonly>
                            <mat-label>Telefonnummer</mat-label>
                            <input matInput
                                   [disabled]="isWestnetzUser"
                                   [(ngModel)]="netzbetreiber.kontaktInfos.telefonAnsprechpartnerRedispatch"
                                   #telefonAnsprechpartnerRedispatch="ngModel"
                                   pattern="^\+\d{1,15}$"
                                   name="telefonAnsprechpartnerRedispatch"
                                   redispatchNullValue/>
                            @if (telefonAnsprechpartnerRedispatch?.errors?.pattern) {
                                <mat-error>
                                    Diese Telefonnr. entspricht nicht dem internationalen E.164-Format, das aus einem +
                                    mit
                                    maximal 15
                                    darauffolgenden Ziffern ohne Leerzeichen oder Schrägstriche besteht. Bsp:
                                    +492011234567
                                </mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field redispatchProvideReadonly>
                            <mat-label>Telefonnummer</mat-label>
                            <input matInput
                                   [disabled]="isWestnetzUser"
                                   [(ngModel)]="netzbetreiber.kontaktInfos.emailAnsprechpartnerRedispatch"
                                   #emailAnsprechpartnerRedispatch="ngModel"
                                   [pattern]="EMAIL_PATTERN"
                                   name="emailAnsprechpartnerRedispatch"
                                   redispatchNullValue/>
                            @if (emailAnsprechpartnerRedispatch?.errors?.pattern) {
                                <mat-error>
                                    Diese E-Mail-Adresse scheint nicht gültig zu sein
                                </mat-error>
                            }
                        </mat-form-field>
                        <h4>Ansprechspartner Kaskade</h4>
                        <mat-form-field redispatchProvideReadonly>
                            <mat-label>Telefonnummer</mat-label>
                            <input matInput
                                   [disabled]="isWestnetzUser"
                                   [(ngModel)]="netzbetreiber.kontaktInfos.telefonAnsprechpartnerKaskade"
                                   #telefonAnsprechpartnerKaskade="ngModel"
                                   pattern="^\+\d{1,15}$"
                                   name="telefonAnsprechpartnerKaskade"
                                   redispatchNullValue/>
                            @if (telefonAnsprechpartnerKaskade?.errors?.pattern) {
                                <mat-error>
                                    Diese Telefonnr. entspricht nicht dem internationalen E.164-Format, das aus einem +
                                    mit
                                    maximal 15
                                    darauffolgenden Ziffern ohne Leerzeichen oder Schrägstriche besteht. Bsp:
                                    +492011234567
                                </mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field redispatchProvideReadonly>
                            <mat-label>Telefonnummer</mat-label>
                            <input matInput
                                   [disabled]="isWestnetzUser"
                                   [(ngModel)]="netzbetreiber.kontaktInfos.emailAnsprechpartnerKaskade"
                                   #emailAnsprechpartnerKaskade="ngModel"
                                   [pattern]="EMAIL_PATTERN"
                                   name="emailAnsprechpartnerKaskade"
                                   redispatchNullValue/>
                            @if (emailAnsprechpartnerKaskade?.errors?.pattern) {
                                <mat-error>
                                    Diese E-Mail-Adresse scheint nicht gültig zu sein
                                </mat-error>
                            }
                        </mat-form-field>
                        <h4>Ansprechspartner netzführende Stelle</h4>
                        <mat-form-field redispatchProvideReadonly>
                            <mat-label>Telefonnummer</mat-label>
                            <input matInput
                                   [disabled]="isWestnetzUser"
                                   [(ngModel)]="netzbetreiber.kontaktInfos.telefonAnsprechpartnerNfs"
                                   #telefonAnsprechpartnerNfs="ngModel"
                                   pattern="^\+\d{1,15}$"
                                   name="telefonAnsprechpartnerNfs"
                                   redispatchNullValue/>
                            @if (telefonAnsprechpartnerNfs?.errors?.pattern) {
                                <mat-error>
                                    Diese Telefonnr. entspricht nicht dem internationalen E.164-Format, das aus einem +
                                    mit
                                    maximal 15
                                    darauffolgenden Ziffern ohne Leerzeichen oder Schrägstriche besteht. Bsp:
                                    +492011234567
                                </mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field redispatchProvideReadonly>
                            <mat-label>E-Mail</mat-label>
                            <input matInput
                                   [disabled]="isWestnetzUser"
                                   [(ngModel)]="netzbetreiber.kontaktInfos.emailAnsprechpartnerNfs"
                                   #emailAnsprechpartnerNfs="ngModel"
                                   [pattern]="EMAIL_PATTERN"
                                   name="emailAnsprechpartnerNfs"
                                   redispatchNullValue/>
                            @if (emailAnsprechpartnerNfs?.errors?.pattern) {
                                <mat-error>
                                    Diese E-Mail-Adresse scheint nicht gültig zu sein
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div [fxLayout]="'column'" fxFlex fxLayoutGap="1rem">
                        <h4 class="none-top-margin">Allgemeine Kommunikation TNB - TDL </h4>
                        <mat-form-field redispatchProvideReadonly>
                            <mat-label>E-Mail - 1</mat-label>
                            <input matInput
                                   [disabled]="isWestnetzUser"
                                   [(ngModel)]="netzbetreiber.kontaktInfos.emailKommunikation1"
                                   #emailKommunikation1="ngModel"
                                   [pattern]="EMAIL_PATTERN"
                                   name="emailKommunikation1"
                                   redispatchNullValue/>
                            @if (emailKommunikation1?.errors?.pattern) {
                                <mat-error>
                                    Diese E-Mail-Adresse scheint nicht gültig zu sein
                                </mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field redispatchProvideReadonly>
                            <mat-label>E-Mail - 2</mat-label>
                            <input matInput
                                   [disabled]="isWestnetzUser"
                                   [(ngModel)]="netzbetreiber.kontaktInfos.emailKommunikation2"
                                   #emailKommunikation2="ngModel"
                                   [pattern]="EMAIL_PATTERN"
                                   name="emailKommunikation2"
                                   redispatchNullValue/>
                            @if (emailKommunikation2?.errors?.pattern) {
                                <mat-error>
                                    Diese E-Mail-Adresse scheint nicht gültig zu sein
                                </mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field redispatchProvideReadonly>
                            <mat-label>E-Mail - 3</mat-label>
                            <input matInput
                                   [disabled]="isWestnetzUser"
                                   [(ngModel)]="netzbetreiber.kontaktInfos.emailKommunikation3"
                                   #emailKommunikation3="ngModel"
                                   [pattern]="EMAIL_PATTERN"
                                   name="emailKommunikation3"
                                   redispatchNullValue/>
                            @if (emailKommunikation3?.errors?.pattern) {
                                <mat-error>
                                    Diese E-Mail-Adresse scheint nicht gültig zu sein
                                </mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field redispatchProvideReadonly>
                            <mat-label>E-Mail - 4</mat-label>
                            <input matInput
                                   [disabled]="isWestnetzUser"
                                   [(ngModel)]="netzbetreiber.kontaktInfos.emailKommunikation4"
                                   #emailKommunikation4="ngModel"
                                   [pattern]="EMAIL_PATTERN"
                                   name="emailKommunikation4"
                                   redispatchNullValue/>
                            @if (emailKommunikation4?.errors?.pattern) {
                                <mat-error>
                                    Diese E-Mail-Adresse scheint nicht gültig zu sein
                                </mat-error>
                            }
                        </mat-form-field>
                        <h4>Adresse</h4>
                        <div fxLayout="row" fxLayoutGap="10px">
                            <mat-form-field redispatchProvideReadonly fxFlex>
                                <mat-label>Strasse</mat-label>
                                <input matInput
                                       [disabled]="isWestnetzUser"
                                       [(ngModel)]="netzbetreiber.adresse.strasse"
                                       #strasse="ngModel"
                                       name="strasse"
                                       redispatchNullValue/>
                            </mat-form-field>
                            <mat-form-field redispatchProvideReadonly>
                                <mat-label>Hausnr.</mat-label>
                                <input matInput
                                       [disabled]="isWestnetzUser"
                                       [(ngModel)]="netzbetreiber.adresse.hausnummer"
                                       #hausnummer="ngModel"
                                       name="hausnummer"
                                       redispatchNullValue/>
                            </mat-form-field>
                        </div>
                        <div fxLayout="row" fxLayoutGap="10px">
                            <mat-form-field redispatchProvideReadonly>
                                <mat-label>Postleitzahl</mat-label>
                                <input matInput
                                       [disabled]="isWestnetzUser"
                                       [(ngModel)]="netzbetreiber.adresse.plz"
                                       #plz="ngModel"
                                       name="plz"
                                       pattern="[0-9]{5}"
                                       redispatchNullValue/>
                                @if (plz?.errors?.pattern) {
                                    <mat-error
                                    >
                                        Bitte geben Sie eine fünfstellige Postleitzahl ein
                                    </mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field redispatchProvideReadonly fxFlex>
                                <mat-label>Stadt</mat-label>
                                <input matInput
                                       [disabled]="isWestnetzUser"
                                       [(ngModel)]="netzbetreiber.adresse.stadt"
                                       #stadt="ngModel"
                                       name="stadt"
                                       redispatchNullValue/>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card>
            </div>
        </div>
    </form>
}
